import { render, staticRenderFns } from "./CardCoodevedores.vue?vue&type=template&id=18f85aa0&scoped=true"
import script from "./CardCoodevedores.vue?vue&type=script&lang=js"
export * from "./CardCoodevedores.vue?vue&type=script&lang=js"
import style0 from "./CardCoodevedores.vue?vue&type=style&index=0&id=18f85aa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f85aa0",
  null
  
)

export default component.exports